import { Button, Snackbar } from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";
import { useTranslation } from "react-i18next";
import { useShareButton } from "./useShareButton";

interface ShareButtonProps {
  claimId?: string;
}

export function ShareButton({ claimId }: ShareButtonProps) {
  const { open, handleShare, handleClose } = useShareButton(claimId);
  const { t } = useTranslation();

  return (
    <>
      <Button variant="outlined" startIcon={<ShareIcon />} onClick={handleShare}>
        {t("share.button")}
      </Button>
      <Snackbar
        open={open}
        onClose={handleClose}
        autoHideDuration={2500}
        message={t("share.copied")}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
    </>
  );
}
